import { P2GBox, P2GGrid } from '@parcel2go/core-ui';
import { CmsContent } from '@parcel2go/npm-p2g-app';
import React from 'react';

export const NoTrackingResultAdditionalContent: React.FC = () => {
  return (
    <>
      <P2GBox>
        <CmsContent contentKey="NO.TRACKING.RESULT.ADDITIONAL.CONTENT" />
      </P2GBox>
      <P2GBox pt={1} pb={4}>
        <CmsContent contentKey="NO.TRACKING.SEARCH.ADDITIONAL.CONTENT" />
      </P2GBox>
    </>
  );
};

export const NoTrackingSearchAdditionalContent: React.FC = () => {
  return (
    <P2GGrid item classNames="tracking-serach-content">
      <CmsContent contentKey="NO.TRACKING.SEARCH.ADDITIONAL.CONTENT" />
    </P2GGrid>
  );
};
